import modifierKeyPressed from "./modifierKeyPressed";
var ELEMENTS_TO_IGNORE = ["INPUT", "TEXTAREA"];
export default (function (event, enableOnContentEditable, ignoredElementWhitelist) {
    /**
     * Chrome autocomplete triggers `keydown` event but `event.key` will be undefined.
     * See https://bugs.chromium.org/p/chromium/issues/detail?id=581537.
     */
    if (!event.key && !modifierKeyPressed(event)) {
        return true;
    }
    var target = (event.target || {});
    /**
     * Ignore the keydown event if it originates from a `contenteditable`
     * element, unless the user has overridden this behaviour.
     */
    if (target.isContentEditable && !enableOnContentEditable) {
        return true;
    }
    /**
     * Ignore the keydown event if it originates from one of the
     * `ELEMENTS_TO_IGNORE`, unless the user has whitelisted it.
     */
    return (ELEMENTS_TO_IGNORE.includes(target.nodeName) &&
        !(ignoredElementWhitelist === null || ignoredElementWhitelist === void 0 ? void 0 : ignoredElementWhitelist.includes(target.nodeName)));
});
